import clsx from 'clsx';
import { motion } from 'framer-motion';
import React from 'react';

/**
 * AnimatedButton — a versatile animated button.
 * variant: 'primary' | 'secondary' | 'danger'
 * size: 'sm' | 'md' | 'lg'
 */
export default function AnimatedButton({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  style = {},
  ...props
}) {
  const base =
    'inline-flex items-center justify-center font-body font-semibold rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 select-none cursor-pointer';

  const variants = {
    primary:
      'bg-gradient-to-r from-rose-400 to-petal-500 text-white shadow-lg shadow-rose-200 hover:from-rose-500 hover:to-petal-600 focus:ring-rose-300',
    secondary:
      'bg-white/80 backdrop-blur text-rose-500 border border-rose-200 shadow hover:bg-rose-50 hover:border-rose-300 focus:ring-rose-200',
    danger:
      'bg-white/70 backdrop-blur text-rose-400 border border-rose-200 shadow hover:bg-rose-50 hover:text-rose-500 focus:ring-rose-200',
    ghost:
      'bg-transparent text-rose-400 border border-rose-200 hover:bg-rose-50 focus:ring-rose-200',
  };

  const sizes = {
    sm: 'px-5 py-2 text-sm',
    md: 'px-7 py-3 text-base',
    lg: 'px-10 py-4 text-lg',
  };

  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      className={clsx(base, variants[variant], sizes[size], className, {
        'opacity-60 cursor-not-allowed': disabled,
      })}
      style={style}
      whileHover={disabled ? {} : { scale: 1.06, y: -2 }}
      whileTap={disabled ? {} : { scale: 0.96 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      {...props}
    >
      {children}
    </motion.button>
  );
}
